/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import TextInput from "../../../components/elements/forms/TextInput";
import PhoneInput from "../../../components/elements/forms/PhoneInput";
import SubmitButton from "../../../components/elements/forms/SubmitButton";
import { useAppSelector, useAppDispatch } from "../../../store/hooks";
import { clearMessage } from "../../../store/slices/message";
import useRegister from "../misc/useRegister";
import ModalSuccess from "../../../components/Modal/ModalSuccess";
import ModalNew from "../../../components/Modal/ModalNew";
import SelectDropdown from "../../../components/elements/forms/Select";
import TextInputBox from "../../../components/elements/forms/TextInputBox";

const Register: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(({ loading }) => loading.loading);
  const message = useAppSelector(({ message }) => message.message);
  const status = useAppSelector(({ message }) => message.status);
  const {
    user,
    error,
    isExistingUser,
    warningModal,
    closeWarningModal,
    onChangeHandler,
    onChangeHandle,
    onChangeTextbox,
    onSubmit,
    handleResendContinuationLink,
  } = useRegister();
  console.log("User Data:", user);

  return (
    <div className="font-abel md:py-10 bg-[#F7F7F7] h-full">
      <div className="max-w-[800px] mx-auto">
        <div className=" bg-[white] px-4 py-5 w-full  border border-[#0B60D6] rounded-lg md:px-4 md:pt-5 md:pb-5">
          <div className="md:max-w-[600px] mx-auto">
            <div className="text-center w-full">
              <div className="py-2 px-5 bg-[#0B60D6] text-white rounded-full flex justify-center max-w-[350px] mx-auto mb-2">
                <h3 className="md:text-[28px] text-[20px]">Book Your Demo</h3>
              </div>
              <p className="text-center text-[14px] text-gray-600 pb-4 max-w-[490px] mx-auto">
                Complete this quick form to access the demo. We may reach out
                for any additional support.
              </p>
            </div>
            <div className="h-[100%] w-full mx-auto py-4 px-4">
              <div className="w-[100%] max-w-[600px] grid grid-cols-1 md:grid-cols-2 gap-2">
                <TextInput
                  label="Company Name"
                  placeholder="Company Name"
                  name="name"
                  status={error.name}
                  value={user.name}
                  onChange={onChangeHandler}
                  required={true}
                />
                <TextInput
                  label="Work Email"
                  placeholder="jane.doe@company.com"
                  name="representativeEmail"
                  status={error.representativeEmail}
                  value={user.representativeEmail}
                  onChange={onChangeHandler}
                  required={true}
                />
                <TextInput
                  label="First Name"
                  placeholder="John"
                  name="representativeFirstName"
                  value={user.representativeFirstName}
                  status={error.representativeFirstName}
                  onChange={onChangeHandler}
                  required={true}
                />
                <TextInput
                  label="Last Name"
                  placeholder="Doe"
                  name="representativeLastName"
                  value={user.representativeLastName}
                  status={error.representativeLastName}
                  onChange={onChangeHandler}
                  required={true}
                />
                <PhoneInput
                  label="Phone Number"
                  placeholder="8012345678"
                  name="contactPhone"
                  value={user.contactPhone}
                  onChange={onChangeHandler}
                />
                <SelectDropdown
                  items={[
                    { id: "CEO", name: "CEO" },
                    { id: "CTO", name: "CTO" },
                    { id: "C_Level", name: "C-Level Executive" },
                    { id: "HR_Director_VP", name: "HR Director/VP" },
                    { id: "Hiring_Manager", name: "Hiring Manager" },
                    {
                      id: "Talent_Acquisition",
                      name: "Recruiter/Talent Acquisition",
                    },
                    { id: "Other", name: "Other" },
                  ]}
                  name="representativeRole"
                  label="Role / Department"
                  value={user.representativeRole || ""}
                  onChange={onChangeHandle}
                  status={error.representativeRole}
                  required={true}
                />
                <SelectDropdown
                  items={[
                    { id: "1-50", name: "1-50" },
                    { id: "51-200", name: "51-200" },
                    { id: "201-500", name: "201-500" },
                    { id: "501-1000", name: "501-1000" },
                    { id: "1001-5000", name: "1001-5000" },
                    { id: "5000+", name: "6000+" },
                  ]}
                  name="companySize"
                  label="Company Size"
                  value={user.companySize || ""}
                  onChange={onChangeHandle}
                  status={error.companySize}
                  required={true}
                />
                <TextInput
                  label="Current Hiring System (ATS)?"
                  placeholder="e.g. Greenhouse, Zoho, etc."
                  name="atsSystem"
                  value={user.atsSystem}
                  onChange={onChangeHandler}
                />
                <div className="col-span-1 md:col-span-2">
                  <SelectDropdown
                    items={[
                      { id: "LinkedIn", name: "LinkedIn" },
                      { id: "Email", name: "Email" },
                      { id: "Google_Search", name: "Google Search" },
                      { id: "Referral", name: "Referral" },
                      { id: "Social_Media", name: "Social Media" },
                      { id: "Advertisement", name: "Advertisement" },
                      { id: "Event_Webinar", name: "Event/Webinar" },
                      { id: "Friend", name: "Friend" },
                      { id: "Other", name: "Other" },
                    ]}
                    name="referralSource"
                    label="How did you hear about us?"
                    value={user.referralSource || ""}
                    onChange={onChangeHandle}
                  />
                </div>
              </div>
              <TextInputBox
                label="What is your biggest hiring challenge?"
                rows={4}
                placeholder="e.g., High volume of applicants, screening technical roles, slow time-to-hire..."
                name="challengeDescription"
                value={user.challengeDescription}
                status={error.challengeDescription}
                onChange={onChangeTextbox}
                min={3}
                required={true}
              />
              <div className="w-[100%] mt-3">
                <SubmitButton
                  title="Submit"
                  onSubmitHandler={onSubmit}
                  loading={loading}
                  className="font-[400] text-white md:hover:bg-[white] md:hover:text-[#243677] hover:border-[#0B60D6] rounded-full"
                />
              </div>
              <p className="text-center text-[14px] text-gray-600 pt-4 max-w-[480px] mx-auto">
                Your information is secure and used only for demo scheduling
                purposes.
              </p>
              {/* Success modal */}
              <ModalSuccess
                open={status === "success" && message ? true : false}
                btnText="Back to home"
                link="/"
                onClose={() => dispatch(clearMessage())}
              ></ModalSuccess>

              {/* Email already registered — warning modal */}
              <ModalNew
                isOpen={warningModal.open}
                onClose={closeWarningModal}
                title=""
              >
                <div className="flex flex-col items-center text-center gap-4 py-4 px-2">
                  {/* Warning icon */}
                  <div className="w-16 h-16 rounded-full bg-amber-50 flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-9 h-9 text-amber-500"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
                      <path d="M12 9v4" />
                      <path d="M12 17h.01" />
                    </svg>
                  </div>

                  <div>
                    <h3 className="text-[22px] font-semibold text-gray-900 mb-2">
                      Email Already Registered
                    </h3>
                    <p className="text-[15px] text-gray-600 leading-relaxed max-w-[360px]">
                      {warningModal.message}
                    </p>
                  </div>

                  <div className="flex flex-col gap-2 w-full mt-2">
                    <SubmitButton
                      title="Resend Onboarding Link"
                      onSubmitHandler={async () => {
                        await handleResendContinuationLink();
                        closeWarningModal();
                      }}
                      loading={loading}
                      className="font-[400] text-white hover:text-white rounded-full bg-[#0B60D6] hover:bg-[#0948a8]"
                    />
                    <button
                      onClick={closeWarningModal}
                      className="text-[14px] text-gray-500 hover:text-gray-700 underline mt-1"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </ModalNew>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
